<template>
  <div>
    <div style="margin-bottom: 10px">
      <CustCard
        :title="$l('form_header_baseInfo') || '客户信息'"
        :desc="
          $l('form_desc_baseInfo') ||
          '客户公司名称、税号（国外公司VAT No，国内公司统一征信码）、背景情况等基础信息'
        "
      >
        <CustBase :formData="formData" />
      </CustCard>

      <CustCard
        :title="$l('form_header_factoryInfo') || '验厂相关'"
        :desc="$l('form_desc_factoryInfo') || '客户对验厂相关要求'"
      >
        <el-form size="mini" label-position="top">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_isFactoryInspection') || '是否需要验厂'"
              >
                <el-input v-model="formData.isFactoryInspection" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_factoryInspectionMethods') || '验厂方式'"
              >
                <el-input
                  v-model="formData.factoryInspectionMethods"
                  readonly
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </CustCard>
      <CustCard
        :title="$l('form_header_businessSet') || '业务设置'"
        :desc="
          $l('form_desc_businessSet') ||
          '客户服务团队人员配置，相关业务参数设置'
        "
        style="margin-bottom: 10px"
      >
        <CustTakeOrder :custCode="custCode" :formData="formData" />
      </CustCard>
    </div>
  </div>
</template>
<script>
import CustCard from '../cust-card'
import CustBase from './cust-base'
import CustTakeOrder from './cust-take-order'

export default {
  components: { CustBase, CustCard, CustTakeOrder },

  props: {
    formData: { type: Object, default: () => {} },
    custCode: { type: String, default: '' },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-card {
    border: none;
  }
  .el-card__body {
    padding: 15px;
  }

  .ql-editor,
  .el-input .el-input__inner[readonly='readonly'] {
    background-color: #f9f9f9;
    border: none !important;
  }

  .header-card {
    margin-bottom: 10px;
    .el-card__body {
      padding-bottom: 0;
    }
  }
}
</style>
